import React from 'react';
import PropTypes from 'prop-types';

import {DeleteAttachmentModal} from './DeleteAttachmentModal/DeleteAttachmentModal';
import translate from '../../../../utils/translations';
import edap from '@homeaway/edap-wrapper';
import request from 'superagent';
import {AlertDanger} from '@homeaway/react-alerts';
import {CLOSE__12} from '@homeaway/svg-defs/lib/defs/CLOSE__12';
import {SVGIcon} from '@homeaway/react-svg';

import './DeleteAttachment.less';

export class DeleteAttachment extends React.Component {
    static propTypes = {
        attachmentId: PropTypes.string.isRequired,
        downloadUrl: PropTypes.string.isRequired,
        fileName: PropTypes.string.isRequired,
        onDeleteComplete: PropTypes.func.isRequired,
        role: PropTypes.string.isRequired,
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        translations: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            isError: false,
            isOpen: false,
        };
    }

    handleOpen = () => {
        this.setState({isOpen: true});
        edap().push({
            name: 'generic.modal',
            data: {
                modalaction: 'open',
                modalname: 'deleteAttachmentModalView',
            },
        });
    };

    handleClose = () => {
        this.setState({isOpen: false});
        edap().push({
            name: 'generic.modal',
            data: {
                modalaction: 'close',
                modalname: 'deleteAttachmentModalView',
            },
        });
    };

    onDelete = () => {
        this.setState({isError: false});
        const {attachmentId, onDeleteComplete} = this.props;
        request
            .delete(
                `/bizops/travelerHome/attachments?attachmentUUID=${attachmentId}`
            )
            .end((error) => {
                if (!error) {
                    onDeleteComplete(attachmentId);
                } else {
                    this.setState({isError: true});
                }
            });
    };

    render() {
        const {fileName, translations} = this.props;

        return (
            <div className="DeleteAttachment">
                {this.state.isError && (
                    <AlertDanger
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.alert.status.retry'
                        )}
                    />
                )}
                <div className="Token">
                    <a
                        className="Token__value"
                        target="_blank"
                        href={this.props.downloadUrl}
                    >
                        {this.props.fileName}
                    </a>
                    {this.props.role === 'TRAVELER' && (
                        <button
                            className="Token__remove"
                            onClick={this.handleOpen}
                        >
                            <SVGIcon markup={CLOSE__12} />
                        </button>
                    )}
                </div>
                <DeleteAttachmentModal
                    fileName={fileName}
                    isOpen={this.state.isOpen}
                    onClose={this.handleClose}
                    onDelete={this.onDelete}
                    translations={translations}
                />
            </div>
        );
    }
}

export default DeleteAttachment;
